import type React from 'react';
import { type KeyboardLayout, KeyboardLayoutContext } from './keyboard-layout-context';

export interface WordsHappenKeyboardLayoutProviderProps {
  /** The layout for every `Keyboard` below this provider that does not pass its own `layout`. */
  layout: KeyboardLayout;
  children: React.ReactNode;
}

/**
 * Sets the layout of every `Keyboard` below it, as `WordsHappenMotionProvider` does for motion, so a game renders the
 * player's choice without passing it through by hand.
 */
export const WordsHappenKeyboardLayoutProvider: React.FC<WordsHappenKeyboardLayoutProviderProps> = ({
  layout,
  children,
}) => <KeyboardLayoutContext.Provider value={layout}>{children}</KeyboardLayoutContext.Provider>;
